export enum ChartType {
  LINE = "Line",
  BAR = "Bar",
}

export enum ExportType {
  PNG = "image/png",
  SVG = "image/svg+xml",
}

/**
 * Data type passed to the chart
 */
export type TimeSeries = {
  id: string;
  name: string;
  type: ChartType;
  data: {
    value: number | null;
    valueLabel?: string;
    date: Date;
    dateLabel?: string;
    source?: string;
  }[];
  metadata?: {
    is_daily?: boolean;
  };
};

/**
 * Data type for TimeSeries to partially update the series in the chart.
 * All properties except id are optional.
 */
export type UpdateTimeSeries = Partial<TimeSeries> & { id: string };

/**
 * Type for chart configuration (can be used to update the chart).
 */
export type ChartConfig = {
  chart?: {
    title?: string;
    subtitle?: string;
  };
  xAxis?: {
    title?: string;
    aggregatedToMonth?: any; // When aggregated data (e.g. Jan-Mar) tell which month the data is aggregated to
  };
  yAxis?: {
    title?: string;
    isPercent?: boolean;
  };
  data?: {
    showPrevious?: boolean; // Show previous years data
  };
};

/**
 * Type for a function the chart can use to format numbers
 */
export type NumberFormatter = (
  value: number,
  isPercent?: boolean,
  locale?: string
) => string;

export interface TimeSeriesChartInterface {
  init(renderTo: HTMLDivElement, numberFormatter?: NumberFormatter): void;

  /**
   * Add series to the chart
   *
   * @param timeSeries - An array of time series
   * @param chartConfig - Additional chart configuration to update axis etc.
   */
  addTimeSeries(timeSeries: TimeSeries[], chartConfig?: ChartConfig): void;

  updateTimeSeries(
    timeSeries: UpdateTimeSeries[],
    chartConfig?: ChartConfig
  ): void;

  removeTimeSeries(ids: string[], chartConfig?: ChartConfig): void;

  getTimeSeries(): TimeSeries[];

  export(type: ExportType): void;

  print(): void;
}
